import type { Session, SessionHeader } from "../models";
import { dataUri } from "./manifest";
import type { SessionSource, Snapshot } from "./types";

const cache = new Map<string, Promise<Session>>();

function fetchSession(uri: string): Promise<Session> {
  let p = cache.get(uri);
  if (!p) {
    p = fetch(dataUri(uri)).then((r) => {
      if (!r.ok) throw new Error(`session fetch failed: ${r.status}`);
      return r.json() as Promise<Session>;
    });
    cache.set(uri, p);
  }
  return p;
}

export function makeReplaySource(uriById: (id: string) => string): SessionSource {
  return {
    mode: "replay",
    async loadHeader(sessionId: string): Promise<SessionHeader> {
      const s = await fetchSession(uriById(sessionId));
      return {
        id: s.id,
        tenant: s.tenant,
        project: s.project,
        user: s.user,
        title: s.title,
        started_at: s.started_at,
        ended_at: s.ended_at,
        duration_ms: s.duration_ms,
        turn_count: s.turn_count,
        status: s.status,
        model_class: s.model_class,
        scores: s.scores,
        scenario: s.scenario,
      };
    },
    async snapshot(sessionId: string): Promise<Snapshot> {
      const s = await fetchSession(uriById(sessionId));
      return { turns: s.turns, observations: s.observations, closed: s.status === "closed" };
    },
    // No subscribe — replay has no incremental stream beyond the snapshot.
    close() {
      // cache is intentionally session-lifetime; nothing to clean up.
    },
  };
}
